import RetailerSubscription from './RetailerSubscription'

export default RetailerSubscription
